interface CodeName {
  code?: string
  name?: string
}

export function makeFilterByCodeName(inputValue: string) {
  if (!inputValue) {
    return () => true
  }
  const lowerInputValue = inputValue.toLowerCase()
  return ({ code, name }: CodeName) =>
    code?.toLowerCase().includes(lowerInputValue) || name?.toLowerCase().includes(lowerInputValue)
}
